import React from 'react'


import { tw } from 'tagged-classnames-free';
export interface ItemWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
}

const ItemWrapper: React.FC<ItemWrapperProps> = (props) => {
  const { className, ...rest } = props
  return (
    <div
      className={tw`hover:bg-f-bg-base music-item music-item-wrapper flex items-center justify-between gap-8 rounded-lg p-3 transition ${className}`}
      {...rest}
    ></div>
  )
}

export default ItemWrapper
